import {Box, Typography} from '@mui/material';

import {
  culturalFitDetailListItemSx,
  culturalFitDetailSectionBlockSx,
  culturalFitDetailSectionLabelSx,
  culturalFitDetailSectionListSx,
} from './workforceProfileCulturalFitAnalysisSectionSx';
import {PillarDetailSection} from '../../utils/WorkforceProfileDetail/workforceProfileCulturalFitAnalysisUtils';

export interface Props {
  sections: PillarDetailSection[];
}

export const WorkforceCulturalFitPillarDetailPanel = ({sections}: Props) => (
  <Box>
    {sections.map((section) => (
      <Box key={section.key} sx={culturalFitDetailSectionBlockSx}>
        <Typography variant='caption' sx={culturalFitDetailSectionLabelSx}>
          {section.label}
        </Typography>
        <Box component='ul' sx={culturalFitDetailSectionListSx}>
          {section.items.map((item) => (
            <Typography
              component='li'
              key={item}
              variant='body2'
              color='text.secondary'
              sx={culturalFitDetailListItemSx}
            >
              {item}
            </Typography>
          ))}
        </Box>
      </Box>
    ))}
  </Box>
);
